import callApi from "../api/HTTPClient";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useCallRestApi = () => {
  const callRestApi = async <T>({ link, resource, onSuccess, onError, onFinally }: Partial<RestApiProps<T>>) => {
    if (link)
      await callApi(link, resource)
        .then((res) => {
          if (onSuccess) onSuccess(res.data);
        })
        .catch((err) => {
          if (err.message === "Network Error" || err.code === "ECONNABORTED") {
            const errorApi: ErrorApi = {
              status: "ECONNABORTED or Network Error",
              timestamp: "",
              message: "Falha ao conectar com a API",
              debugMessage: "ECONNABORTED ou Network Error",
              subErrors: null,
              type: "error",
            };
            if (onError) onError(errorApi);
            return;
          } else if (err.response && err.response.data) {
            const errorApi: ErrorApi = err.response.data as ErrorApi;
            if (onError) onError({ ...errorApi, type: "warn" });
          }
        })
        .finally(() => {
          if (onFinally) onFinally();
        });
  };

  return [callRestApi] as const;
};

export default useCallRestApi;
